<script setup lang="ts">
import {
    isNaturalProfileAttributeLocked,
    usePersonalAccountDataState,
} from '../../../../utilities/account/useAccountDataPersonal'
import BaseInputText from '../../../base/BaseInputText.vue'
import { DeviceMobileIcon, MailIcon, PhoneIcon } from '@heroicons/vue/solid'
import {
    condaShowEmailChangeNotice,
    isNaturalProfileAttributeHidden,
    isRequiredNaturalProfileAttributesForInvestment,
    isRequiredRequiredNaturalProfileAttributes,
} from '../../../../validation'
import { initPersonalAccountForm } from '../../../../utilities/account/useAccountFormPersonal'
import { InformationCircleIcon } from '@heroicons/vue/outline'
import { ref } from 'vue'

const { naturalProfile: account } = usePersonalAccountDataState()
initPersonalAccountForm('Contact Data')

const showInformationDiv = ref(false)

function toggleInfo(e) {
    e.preventDefault()
    showInformationDiv.value = !showInformationDiv.value
}
</script>

<template>
    <div
        v-show="showInformationDiv"
        class="flex items-start space-x-4 border-t border-gray-200 bg-gray-50 px-4 py-5 sm:px-6">
        <InformationCircleIcon class="w-7 flex-none"></InformationCircleIcon>
        <p class="self-center text-sm text-gray-600" v-html="$t('account_settings.contact_data_subtitle')"></p>
    </div>
    <div class="grid grid-cols-1 gap-x-4 gap-y-8 px-4 py-5 sm:grid-cols-2 sm:px-6">
        <div v-if="!isNaturalProfileAttributeHidden('mobile_number')" class="sm:col-span-1">
            <BaseInputText
                v-model="account.mobile_number"
                :required="isRequiredRequiredNaturalProfileAttributes('mobile_number')"
                :required-2="isRequiredNaturalProfileAttributesForInvestment('mobile_number')"
                :disabled="isNaturalProfileAttributeLocked('mobile_number')"
                :icon="DeviceMobileIcon"
                name="account.mobile_number"
                :info="true"
                :info-action="toggleInfo"
                :label="$t('account.mobile_number')">
            </BaseInputText>
        </div>
        <div v-if="!isNaturalProfileAttributeHidden('phone_number')" class="sm:col-span-1">
            <BaseInputText
                v-model="account.phone_number"
                :required="isRequiredRequiredNaturalProfileAttributes('phone_number')"
                :required-2="isRequiredNaturalProfileAttributesForInvestment('phone_number')"
                :disabled="isNaturalProfileAttributeLocked('phone_number')"
                :icon="PhoneIcon"
                name="account.phone_number"
                :label="$t('account.phone_number')" />
        </div>
        <div class="sm:col-span-1">
            <BaseInputText
                v-model="account.email"
                :icon="MailIcon"
                :label="$t('account.current_email')"
                name="account.email"
                disabled />
        </div>
        <div v-if="!isNaturalProfileAttributeHidden('email_pending')" class="sm:col-span-1">
            <BaseInputText
                v-model="account.email_pending"
                :required="isRequiredRequiredNaturalProfileAttributes('email_pending')"
                :required-2="isRequiredNaturalProfileAttributesForInvestment('email_pending')"
                :disabled="isNaturalProfileAttributeLocked('email')"
                :icon="MailIcon"
                :label="$t('account.email_pending')"
                name="account.email_pending" />
        </div>
        <div v-if="condaShowEmailChangeNotice()" class="-mt-6 text-xs sm:col-span-2">
            {{ $t('texts.email_change_notice') }}
        </div>
    </div>
</template>
